import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SnotifyToastConfig, SnotifyService, SnotifyPosition } from 'ng-snotify';
import { NgSelectConfig } from '@ng-select/ng-select';
import { ISlimScrollOptions } from 'ngx-slimscroll';
import { IResult } from './shared/models/result.model';
import { ToastPositionService } from './shared/services/toast-position.service';
import { ToastOptions, ToastData, ToastaService } from 'ngx-toasta';
import { IMyDateModel } from 'angular-mydatepicker';
import { FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';

@Injectable()
export class AppConfig {
  style = 'material';
  timeout = 3000;
  position: SnotifyPosition = SnotifyPosition.rightCenter;
  progressBar = true;
  closeClick = true;
  newTop = true;
  filterDuplicates = false;
  backdrop = -1;
  dockMax = 8;
  blockMax = 6;
  pauseHover = true;
  titleMaxLength = 15;
  bodyMaxLength = 80;

  private config = {
    name: 'REDNOVATION',
    title: 'Red Promocional Mexicana',
    version: '1.0',
    code: 'f6GCgCHp1zkKck7JGIt1mxEStPlQmEFB',
    debug: true
  };
  constructor(private snotifyService: SnotifyService
    , private configSelect: NgSelectConfig
    , private toastaService: ToastaService
    , private toastPositionService: ToastPositionService
    , private datePipe: DatePipe) {
    this.configSelect.notFoundText = 'Valor no encontrado';
    this.toastPositionService.setPosition('bottom-right');
  }

  public getConfig(): any {
    return this.config;
  }
  public configModal = {
    backdrop: true,
    ignoreBackdropClick: true,
    keyboard: false,
  };
  public getConfigToast(): SnotifyToastConfig {
    this.snotifyService.setDefaults({
      global: {
        newOnTop: this.newTop,
        maxAtPosition: this.blockMax,
        maxOnScreen: this.dockMax
      }
    });
    return {
      bodyMaxLength: this.bodyMaxLength,
      titleMaxLength: this.titleMaxLength,
      backdrop: this.backdrop,
      position: this.position,
      timeout: this.timeout,
      showProgressBar: this.progressBar,
      closeOnClick: this.closeClick,
      pauseOnHover: this.pauseHover
    };
  }
  public getConfigSlimScroll(): ISlimScrollOptions {
    return {
      position: 'right', // left | right
      barBackground: '#18A689', // #C9C9C9
      barOpacity: '0.8', // 0.8
      barWidth: '10', // 10
      barBorderRadius: '20', // 20
      barMargin: '0', // 0
      gridBackground: '#d9d9d9', // #D9D9D9
      gridOpacity: '1', // 1
      gridWidth: '2', // 2
      gridBorderRadius: '20', // 20
      gridMargin: '0', // 0
      alwaysVisible: true, // true
      visibleTimeout: 1000, // 1000
    }
  }
  public notificationSuccessError(result: IResult): boolean {
    if (result.isCorrect === true) {
      this.newToast('Éxito', result.message, 'success');
    } else {
      this.newToast('Error', result.message, 'error');
    }

    return result.isCorrect;
  }
  public b64toBlob(b64Data, contentType, sliceSize): Blob {
    contentType = contentType || '';
    sliceSize = sliceSize || 512;

    const byteCharacters = atob(b64Data);
    const byteArrays = [];
    for (let offset = 0; offset < byteCharacters.length; offset += sliceSize) {
      const slice = byteCharacters.slice(offset, offset + sliceSize);

      const byteNumbers = new Array(slice.length);
      for (let i = 0; i < slice.length; i++) {
        byteNumbers[i] = slice.charCodeAt(i);
      }
      const byteArray = new Uint8Array(byteNumbers);
      byteArrays.push(byteArray);
    }

    const blob = new Blob(byteArrays, { type: contentType });
    return blob;
  }
  public newToast(title: string, msg: string, type: string): void {
    const toastOptions: ToastOptions = {
      title: title,
      msg: msg,
      showClose: true,
      showDuration: true,
      timeout: 10000,
      theme: 'bootstrap'
    };
    switch (type) {
      case 'default': this.toastaService.default(toastOptions); break;
      case 'info': this.toastaService.info(toastOptions); break;
      case 'success': this.toastaService.success(toastOptions); break;
      case 'wait': this.toastaService.wait(toastOptions); break;
      case 'error': this.toastaService.error(toastOptions); break;
      case 'warning': this.toastaService.warning(toastOptions); break;
    }
  }
  public getDate(event: IMyDateModel) {
    return event.singleDate.jsDate;
  }
  public getLocalISOTime(myDate: Date): Date {
    if (myDate === undefined || myDate === null) {
      return null;
    }
    const tzoffset = (myDate).getTimezoneOffset() * 60000;
    const localISOTime = (new Date(myDate.getTime() - tzoffset));
    return localISOTime;
  }
  public setDate(date: Date): IMyDateModel {
    const d = new Date(date);
    return { isRange: false, singleDate: { jsDate: d }, dateRange: null };
  }
  public dateFormat(date, format) {
    const map = {
      dd: date.getDate(),
      mm: date.getMonth() + 1,
      yyyy: date.getFullYear()
    }

    return format.replace(/dd|mm|yyyy/gi, matched => map[matched])
  }
  public touchedControls(form: FormGroup): void {
    Object.keys(form.controls).forEach(field => {
      const control = form.get(field);
      control.markAsTouched({ onlySelf: true });
    });
  }

  formatDateyyyMMdd(date: Date): string {
  return this.datePipe.transform(date, 'yyyy-MM-dd')!;
}
  /**Configuración toast */
  themes = [{
    name: 'Default Theme',
    code: 'default'
  }, {
    name: 'Material Design',
    code: 'material'
  }, {
    name: 'Bootstrap',
    code: 'bootstrap'
  }];


  types = [{
    name: 'Default',
    code: 'default',
  }, {
    name: 'Info',
    code: 'info'
  }, {
    name: 'Success',
    code: 'success'
  }, {
    name: 'Wait',
    code: 'wait'
  }, {
    name: 'Error',
    code: 'error'
  }, {
    name: 'Warning',
    code: 'warning'
  }];


  positions = [{
    name: 'Top Left',
    code: 'top-left',
  }, {
    name: 'Top Center',
    code: 'top-center',
  }, {
    name: 'Top Right',
    code: 'top-right',
  }, {
    name: 'Top Full Width',
    code: 'top-fullwidth',
  }, {
    name: 'Bottom Left',
    code: 'bottom-left',
  }, {
    name: 'Bottom Center',
    code: 'bottom-center',
  }, {
    name: 'Bottom Right',
    code: 'bottom-right',
  }, {
    name: 'Bottom Full Width',
    code: 'bottom-fullwidth',
  }, {
    name: 'Center Center',
    code: 'center-center',
  }];
  /** */
}
